/**
 * Workaround for circular dependencies,
 * will be overwritten from `src/assets/js/user-profile.js`
 */
export default {
    setNoCustomAvatar: () => {},
    setNoCustomCover: () => {},
}
